var map = {
	"./404.md": 478,
	"./_template.jsx": 408,
	"./additions/index.md": 479,
	"./adressregister/index.md": 480,
	"./architects/index.md": 481,
	"./browser/browserinfo.md": 482,
	"./browser/index.md": 483,
	"./corporate/index.md": 484,
	"./designprinciples/index.md": 485,
	"./device/index.md": 486,
	"./embedding/index.md": 487,
	"./fontrendering/index.md": 488,
	"./fonts/index.md": 489,
	"./fontvorstellung/index.md": 490,
	"./grid/index.md": 491,
	"./html1x1/index.md": 492,
	"./index.md": 493,
	"./interaction/index.md": 494,
	"./interaction/straftaten.md": 495,
	"./interface/index.md": 496,
	"./interface/smartphoneinfo.md": 497,
	"./interface/speedinfo.md": 498,
	"./navigation/index.md": 499,
	"./paperprototype/index.md": 500,
	"./react.js": 501,
	"./responsive/deviceinfo.md": 502,
	"./responsive/index.md": 503,
	"./servertechnology/index.md": 504,
	"./shop/index.md": 505,
	"./tools/index.md": 506,
	"./typography/index.md": 507,
	"./wiki/index.md": 508,
	"./ziele/index.md": 509
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$
// module id = 477
// module chunks = 0